// extracted by mini-css-extract-plugin
export default {"multiselect":"formMultiSelect_multiselect__W7nEp"};